import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SideBar from "./SideBar/SideBar";
import stylesModule from "./Layout.module.sass";
import optionsSideBar from "./SideBar/optionsSideBar";
import { useDispatch, useSelector } from "react-redux";
import useSocketConnection from "../../hooks/useSocketConnection";
import { handleUpdateDataWorkstation } from "../../redux/workstationsListSlice/workstationsListSlice";
import useViewControl from "../../hooks/useViewControl";
import { ModalError, ModalLoad } from "../Modals/Modals";
import { createSelector } from "@reduxjs/toolkit";
import { useLocation, useMatch } from "react-router-dom";
import TopBar from "./TopBar/TopBar";
import ModalChangeSchedule from "./ModalChangeSchedule/ModalChangeSchedule";
import moment from "moment";
import useUpdateWorkstationData from "../../hooks/useUpdateWorkstationData";
import { supportedLngs } from "../../utils/ConstCapture";
import { LanguageProvider } from "./LanguageContext";
import { useTranslation } from "react-i18next";

const selectorLayoutData = createSelector(
  state => ({
    company: state.userData.company,
    loading: state.dashboard.loading,
    data: state.dashboard.data
  }),
  state => state
);

function Layout(props) {
  const location = useLocation();
  const { children } = props;
  const [modal, setModal] = useState(null);

  const path = window.location.pathname.split("/");
  const pathLanguage = supportedLngs.includes(path[1]) ? path[1] : "en";

  const pathDetected = [
    useMatch({ path: `/${pathLanguage}/workstations`, end: false }),
    useMatch({ path: `/${pathLanguage}/select-parts`, end: false }),
    useMatch({ path: `/${pathLanguage}/dashboard-mo`, end: false }),
    useMatch({ path: `/${pathLanguage}/mo`, end: false })
  ];

  const { company, loading, data } = useSelector(selectorLayoutData);

  const errors = useUpdateWorkstationData();

  const dispatch = useDispatch();
  const socket = useSocketConnection(`company_${company.id}`);
  const redirect = useViewControl();
  let timer = null;
  const { t } = useTranslation("general");

  const handleFinishShift = () => {
    //! UNCOMMENT IT WHEN READY
    setModal(<ModalChangeSchedule unmount={() => setModal(null)} />);
  };

  useEffect(() => {
    if (socket) {
      socket.on("server:changeWorkstationFromTheList", data => {
        dispatch(handleUpdateDataWorkstation(data));
      });
    }
    return () => {
      if (socket) {
        socket.off("server:changeWorkstationFromTheList");
      }
    };
  }, [socket]);

  useEffect(() => {
    setModal(loading ? <ModalLoad /> : null);
  }, [loading]);

  useEffect(() => {
    if (data?.schedule?.ends_at) {
      clearTimeout(timer);

      const { schedule } = data;
      const timeToEnd = moment(schedule.ends_at.split(".")[0]).diff(
        moment(),
        "milliseconds"
      );

      timer = setTimeout(handleFinishShift, timeToEnd);
    } else {
      clearTimeout(timer);
    }
    return () => clearTimeout(timer);
  }, [data]);

  useEffect(() => {
    if (errors.length > 0) {
      setModal(<ModalError unmount={() => setModal(null)} messages={errors} />);
    }
  }, [errors]);

  return (
    <div className={stylesModule.layout}>
      {modal}
      {redirect}
      <LanguageProvider>
        <TopBar />
        <div className={stylesModule.content}>
          {!pathDetected.reduce((prev, current) => prev || current, false) && (
            <SideBar options={optionsSideBar(t)} />
          )}
          <section className={stylesModule.body} id="main-content">
            <div className={stylesModule.scroll} id={"scroll-layout"}>
              {children}
            </div>
          </section>
        </div>
      </LanguageProvider>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default Layout;
